export default function TipsBox(props) {
  return <div>{props.children}</div>;
}

TipsBox.Title = (props) => {
  return <div className="clg-tips-weak-tit">{props.children}</div>;
};

TipsBox.SubTitle = (props) => {
  return (
    <div className="clg-tips-weak-sub-tit" style={props.style}>
      {props.children}
    </div>
  );
};

TipsBox.Text = (props) => {
  return <div className="clg-tips-weak-txt">{props.children}</div>;
};
